import React from 'react';
import { Box, Card, Typography, Button, Link, useTheme } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const AFFILIATE_LINK = "https://go.online-therapy.com/aff_c?offer_id=2&aff_id=5850";

const TherapyReferralBanner = ({ variant = "prominent", isDarkMode }) => {
    const theme = useTheme();

    if (variant === "subtle") {
        return (
            <Box sx={{ 
                textAlign: 'center', 
                py: 1,
                px: 2,
                mb: 1
            }}>
                <Typography variant="caption" color="text.secondary">
                    Need more support?{' '}
                    <Link 
                        href={AFFILIATE_LINK}
                        target="_blank"
                        rel="noopener noreferrer"
                        color="secondary"
                        underline="hover"
                        sx={{ fontWeight: 'bold' }}
                    >
                        Talk to a licensed therapist
                    </Link>
                </Typography>
            </Box>
        );
    }

    // Prominent variant
    return (
        <Card 
            variant="outlined" 
            sx={{ 
                p: 2, 
                mt: 2, 
                mb: 2,
                mx: { xs: 2, sm: 5 }, // Match chat message margins
                backgroundColor: isDarkMode ? 'rgba(235, 100, 64, 0.1)' : 'rgba(235, 100, 64, 0.05)',
                borderColor: 'secondary.main',
                borderWidth: 1,
                borderRadius: 2
            }}
        >
            <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold', color: 'text.primary' }}>
                Talking to a licensed therapist can make a real difference.
            </Typography>
            <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
                Get professional support from the comfort of your home. Save 20% on your first month.
            </Typography>
            <Button 
                variant="contained" 
                color="secondary" 
                href={AFFILIATE_LINK}
                target="_blank"
                rel="noopener noreferrer"
                endIcon={<OpenInNewIcon />}
                fullWidth
                sx={{ 
                    textTransform: 'none',
                    fontWeight: 'bold'
                }}
            >
                Start Online Therapy Today
            </Button>
        </Card>
    );
};

export default TherapyReferralBanner;
